import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core'
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms'
import { EftRecordType_, EftRecordTypes } from '@appShared/services/lookup/[CodeGen]/eft-record-type.domain'
import { IEftRecordSubmission } from '@appShared/interfaces/[Model-based]'

@Component({
   selector: 'app-eft-record',
   templateUrl: './eft-record.component.html',
   styleUrls: ['./eft-record.component.less'],
   changeDetection: ChangeDetectionStrategy.OnPush,
   imports: [ReactiveFormsModule]
})
export class EftRecordComponent implements OnInit {
   @Output() formReady = new EventEmitter<FormGroup>()

   public readonly accountTypes = EftRecordTypes
   public readonly EftRecordType_ = EftRecordType_
   public form!: FormGroup

   constructor(private readonly _fb: FormBuilder) {}

   ngOnInit(): void {
      this.form = this._fb.group({
         routingNumber: ['', [Validators.required, EftRecordComponent.routingNumberValidator()]],
         accountNumber: ['', [Validators.required, Validators.pattern(/^\d{4,17}$/)]],
         accountHolderName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
         accountTypeCode: [EftRecordType_.Checking, [Validators.required]]
      })

      this.formReady.emit(this.form)
   }

   /** Maps the form to the canonical EFT submission shape. */
   getSubmission(): IEftRecordSubmission {
      const value = this.form.getRawValue()
      return {
         accountHolderName: value.accountHolderName,
         accountNumber: value.accountNumber,
         routingNumber: value.routingNumber,
         typeCode: value.accountTypeCode
      } as IEftRecordSubmission
   }

   /*
   * private methods
   * */

   // ABA routing number checksum: 9 digits, weighted (3,7,1) sum % 10 === 0
   private static routingNumberValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
         const raw = (control.value ?? '').toString().replace(/\D/g, '')
         if (!raw) return null
         if (raw.length !== 9) return { routingNumber: true }

         const weights = [3, 7, 1, 3, 7, 1, 3, 7, 1]
         let sum = 0
         for (let i = 0; i < 9; i++) {
            sum += parseInt(raw.charAt(i), 10) * weights[i]
         }
         return sum % 10 === 0 ? null : { routingNumber: true }
      }
   }
}
